import React, { useState } from "react";
import { useLeadData } from "../../profilingForm/hooks/useLeadData";
import { Tooltip } from "react-bootstrap";
import { FiChevronsDown, FiChevronsUp } from "react-icons/fi";
import { convertToUTCString } from "../../../../utils/helpers/helper";

function ProfilingFormDetails({ profilingId }) {
  const [openAccordion, setOpenAccordion] = useState(true);
  const toggleAccordion = () => {
    setOpenAccordion(!openAccordion);
  };
  const data = useLeadData(profilingId, true);
  console.log("Profiling Form Data:", data);
  const enrollment = data.leadData || {};
  return (
    <>
      <div className="card">
        <div className="card-body p-3">
          <div className="d-flex justify-content-between align-items-center">
            <h6 className="mb-1 fw-semibold fs-4 ">Enrollment Details</h6>
            <Tooltip
              title={openAccordion ? "Collapse Details" : "Expand Details"}
            >
              <div style={{ cursor: "pointer" }} onClick={toggleAccordion}>
                {openAccordion ? (
                  <FiChevronsUp size={18} />
                ) : (
                  <FiChevronsDown size={18} />
                )}
              </div>
            </Tooltip>
          </div>

          {openAccordion && (
            <>
              <h6 className="mb-1 mt-1 fw-semibold fs-5 text-decoration-underline">
                Basic Details
              </h6>
              <div className="row mb-2">
                <InfoItem label="Full Name" value={enrollment?.fullName} />
                <InfoItem label="Email" value={enrollment?.email} />
                <InfoItem label="Mobile" value={enrollment?.mobile} />
                <InfoItem label="Course" value={enrollment?.course} />
                <InfoItem label="Medium" value={enrollment?.medium} />
                <InfoItem label="Status" value={enrollment?.status} />
                <InfoItem
                  label="Enrolled On"
                  value={convertToUTCString(enrollment?.enrolledOn)}
                />
              </div>
              <hr />

              {/* Client Details */}
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Client Details
              </h6>
              <div className="row mb-2">
                <InfoItem
                  label="Full Name"
                  value={enrollment?.clientDetails?.fullName}
                />
                <InfoItem
                  label="Mobile"
                  value={enrollment?.clientDetails?.registeredMobileNo}
                />
                <InfoItem
                  label="Email"
                  value={enrollment?.clientDetails?.registeredEmailAddress}
                />
                <InfoItem
                  label="Gender"
                  value={enrollment?.clientDetails?.gender}
                />
                <InfoItem label="Age" value={enrollment?.clientDetails?.age} />
                <InfoItem
                  label="Client Code"
                  value={enrollment?.clientDetails?.clientCode}
                />
                <InfoItem
                  label="City"
                  value={enrollment?.clientDetails?.city}
                />
                <InfoItem
                  label="State"
                  value={enrollment?.clientDetails?.state}
                />
                <InfoItem
                  label="Nominee"
                  value={enrollment?.clientDetails?.nomineeFullName}
                />
              </div>
              <hr />

              {/* Monthly Income */}
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Monthly Income
              </h6>
              <div className="row mb-2">
                <InfoItem
                  label="Salary"
                  value={enrollment?.monthlyIncome?.salary}
                />
                <InfoItem
                  label="Business"
                  value={enrollment?.monthlyIncome?.business}
                />
                <InfoItem
                  label="Agriculture"
                  value={enrollment?.monthlyIncome?.agriculture}
                />
                <InfoItem
                  label="Interest"
                  value={enrollment?.monthlyIncome?.interest}
                />
                <InfoItem
                  label="otherEarnings"
                  value={enrollment?.monthlyIncome?.otherEarnings}
                />
              </div>

              {/* Rental Amounts */}
              {enrollment?.monthlyIncome?.rentalAmounts?.length > 0 && (
                <div className="mb-2">
                  <h6 className="mb-1">Rental Income</h6>
                  {enrollment.monthlyIncome.rentalAmounts.map(
                    (rental, index) => (
                      <div key={index} className="row">
                        <InfoItem label="Type" value={rental.type} />
                        <InfoItem label="Amount" value={rental.amount} />
                      </div>
                    )
                  )}
                </div>
              )}
              <hr />

              {/* Monthly Expenses */}
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Monthly Expenses
              </h6>
              <div className="row mb-2">
                <InfoItem
                  label="Flat Type"
                  value={enrollment?.monthlyExpenses?.flatType}
                />
                <InfoItem
                  label="Flat Amount"
                  value={enrollment?.monthlyExpenses?.flatAmount}
                />
                <InfoItem
                  label="Car EMI"
                  value={enrollment?.monthlyExpenses?.carEmi}
                />
                <InfoItem
                  label="Bike EMI"
                  value={enrollment?.monthlyExpenses?.bikeEmi}
                />
              </div>

              {/* School Fees */}
              {enrollment?.monthlyExpenses?.schoolFees?.length > 0 && (
                <div className="mb-2">
                  <h6 className="mb-1">School Fees</h6>
                  {enrollment.monthlyExpenses.schoolFees.map((fee, index) => (
                    <div key={index} className="row">
                      <InfoItem label="Child" value={fee.child} />
                      <InfoItem label="Amount" value={fee.amount} />
                    </div>
                  ))}
                </div>
              )}
              <hr />

              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Trading And Investment
              </h6>
              <div className="row mb-2">
                <InfoItem
                  label="Trading"
                  value={enrollment?.tradingAndInvestment?.trading.join(",")}
                />
                <InfoItem
                  label="Investment"
                  value={enrollment?.tradingAndInvestment?.investment.join(",")}
                />
                <InfoItem
                  label="Trading Preferences"
                  value={enrollment?.tradingAndInvestment?.tradingPreferences.join(
                    ","
                  )}
                />
              </div>

              {/* Assets */}
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Assets List
              </h6>
              <div className="row mb-2">
                <InfoItem
                  label="Gold Value"
                  value={enrollment?.accetList?.goldValue}
                />
                <InfoItem
                  label="Policy Value"
                  value={enrollment?.accetList?.policyValue}
                />
                <InfoItem
                  label="Bank FD Value"
                  value={enrollment?.accetList?.bankFdValue}
                />
                <InfoItem
                  label="Cash In Bank"
                  value={enrollment?.accetList?.cashInBankValue}
                />
                <InfoItem
                  label="Business Investment"
                  value={enrollment?.accetList?.businessInvestmentValue}
                />
                <InfoItem
                  label="Vehicle Value"
                  value={enrollment?.accetList?.vehicleCarValue}
                />
              </div>

              {/* Real Estate Assets */}
              {enrollment?.assets?.realEstateAssets?.length > 0 && (
                <div className="mb-2">
                  <h6 className="mb-1">Real Estate Assets</h6>
                  {enrollment.assets.realEstateAssets.map((asset, index) => (
                    <div key={index} className="row">
                      <InfoItem label="Property" value={asset.property} />
                      <InfoItem label="Location" value={asset.location} />
                      <InfoItem label="Type" value={asset.assetType} />
                      <InfoItem label="Value" value={asset.value} />
                    </div>
                  ))}
                </div>
              )}
              <hr />
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Libility List
              </h6>

              {/* Real Estate Assets */}
              {enrollment?.libilityList?.length > 0 && (
                <div className="mb-2">
                  <h6 className="mb-1">With type and amount</h6>
                  {enrollment.libilityList.map((asset, index) => (
                    <div key={index} className="row">
                      <InfoItem label={asset.type} value={asset.amount} />
                    </div>
                  ))}
                </div>
              )}
              <hr />

              {/* Call Details */}
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Call Details
              </h6>
              <div className="row mb-2">
                <InfoItem
                  label="Information Call"
                  value={convertToUTCString(enrollment?.informationCallDate)}
                />
                <InfoItem
                  label="Joining Process Call"
                  value={convertToUTCString(enrollment?.joiningProcessCallDate)}
                />
                <InfoItem
                  label="First Service Call"
                  value={convertToUTCString(enrollment?.serviceFirstCallOn)}
                />
                <InfoItem
                  label="Second Service Call"
                  value={convertToUTCString(enrollment?.serviceSecondCallOn)}
                />
                <InfoItem
                  label="Third Service Call"
                  value={convertToUTCString(enrollment?.serviceThirdCallOn)}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

// Helper component for displaying information items
const InfoItem = ({ label, value }) => (
  <div className="d-flex justify-content-between col-md-6 mb-1">
    <span className="col-6 fw-bold">{label}:</span>
    <span className="col-6 text-capitalize">{value || "N/A"}</span>
  </div>
);

export default ProfilingFormDetails;
